
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';
import { Item } from '../store/models/ItemModel';
import { PricingMatrixModel, QuoteData } from '../store/models/QuotesModel';
import { OrdersService } from '@/services/orders-service';
import { CustomerService } from '@/services/customer-service';
import { ConversionHelper } from '@/helpers/ConversionHelper';
import DialogLayout from './DialogLayout.vue';
import { QuickDialog, AlertModel } from '../store/models/DialogModel';
import { QuoteService } from '../services/quote-service';
import { BuildItemAlertMessage } from '@/helpers/ObjectHelper';
import AlertComponent from '@/components/AlertLayout.vue';

import {
  RushOption,
  Orderline,
  OrderlineDetails,
  OrderlinePurchaseStateTypes
} from '@/store/models/OrderlineModel';
import { SetSnackBar } from '@/helpers/SnackbarHelper';
import { DateHelper } from '@/helpers/DateHelper';

@Component({
  components: { DialogLayout, AlertComponent }
})
export default class extends Vue {
  $refs!: {
    quantityInput: HTMLFormElement;
    proofDialogForm: HTMLFormElement;
  };
  /* Properties */
  @Prop({ required: true }) item!: Item;
  @Prop() isImageDoneProccessing!: boolean;

  /* Store Actions */
  @Action('checkForAssociatedOrderlineByItemId', { namespace: 'items' })
  checkForAssociatedOrderlines: any;
  @Getter('getPosAssociatedWithItem', { namespace: 'items' })
  getAssociatedPos: any;

  /* Watchers */
  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (!val) {
      this.dialog = false;
      this.openAlert = false;
      this.$refs.proofDialogForm.reset();
    }
  }
  @Watch('quantity')
  onQuantityChange() {
    this.debounceAction = DateHelper.Debounce(() => {
      this.isCalculatingPrice = true;
      this.calculateProofFees();
    }, this.debounceAction);
  }

  /* Data */
  isAddressLoading: boolean = false;
  isCalculatingPrice: boolean = false;
  isOrderingProof: boolean = false;
  valid: boolean = true;
  lazy: boolean = true;
  rushOption: RushOption = new RushOption();
  rushOptions: RushOption[] = [];
  laminateOptions: any[] = [
    { text: 'No', value: false },
    { text: 'Yes', value: true }
  ];
  laminateOption: boolean = true;
  quantity: number = 1;
  quantitiesOption: number[] = [1, 2, 3, 4, 5];
  orderline: OrderlineDetails[] = [];
  totalPrice: string = '$0.00';
  dialog: boolean = false;
  data: QuickDialog | null = null;
  addresses: any[] = [];
  selectedAddress: any = '';
  openAlert: boolean = false;
  alertOption: AlertModel = new AlertModel();
  debounceAction: any;
  /* Methods */
  async getAllCustomerAddresses() {
    try {
      this.isAddressLoading = true;
      const response = await CustomerService.GetShippingAddressesFull();
      this.addresses = response.data;
      const defaultAddress = this.addresses.find(a => a.IsDefault);
      if (defaultAddress) this.selectedAddress = defaultAddress;
      this.isAddressLoading = false;
    } catch (err) {
      this.isAddressLoading = false;
      SetSnackBar('Something went wrong, please contact Technical support');
    }
  }

  async LoadRushFeeValues() {
    if (this.orderline) {
      try {
        const response = await OrdersService.GetRushFeeValues(
          ConversionHelper.convertOrderlineToAddModel(this.orderline[0])
        );
        this.rushOptions = response.data.filter((d: any) => d.IsAvailable);
      } catch (err) {
        SetSnackBar(
          'Something went wrong loading the rush options, please try refreshing your page or contact Technical support if issue persists.'
        );
      }
    }
  }
  orderProof() {
    this.valid = this.$refs.proofDialogForm.validate();
    if (this.valid) {
      this.isOrderingProof = true;
      const model = {
        ItemId: this.item.Id,
        AddressId: this.selectedAddress.Id,
        DieId: 0,
        Quantity: Number(this.quantity),
        HasFinish: this.laminateOption,
        ShouldChangeStatus: true
      };
      this.$emit('response', model);
    }
  }
  closeAlert() {
    this.openAlert = false;
  }
  onAlertConfirm() {
    this.openAlert = false;
    this.orderProof();
  }
  async onOrderProofClick() {
    if (this.getAssociatedPos[0]) {
      this.openAlert = true;

      return;
    }
    this.orderProof();
  }
  async calculateProofFees() {
    const response = await OrdersService.CalculateProofPrice(this.quantity);
    this.totalPrice = response.data.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
  }

  async getQuoteValue() {
    let quantity = Number(this.quantity);
    const model = new PricingMatrixModel({
      DieId: this.item.Die.Id,
      MaterialId: this.item.Material.Id,
      FinishId: this.item.Finish.Id,
      ColorId: this.item.Color.Id,
      Quantity: quantity,
      StartQuantity: quantity,
      EndQuantity: quantity,
      IncrementBy: 1000,
      ShouldUseVarData: false
    });
    const response = await QuoteService.GetQuoteValues(model);
    if (response.data[2]) {
      let totalprice = response.data[2].TotalCost;
      this.totalPrice = totalprice.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
      });
    }
  }
  async checkIfProofExistsForThisItem() {
    await this.checkForAssociatedOrderlines(this.item.Id);
    if (this.getAssociatedPos[0]) {
      this.alertOption = BuildItemAlertMessage(
        'orderProof',
        this.item,
        this.getAssociatedPos
      );
    }
  }

  async openDialog() {
    this.data = ConversionHelper.convertQuickDialog(this.item);
    this.getAllCustomerAddresses();
    this.calculateProofFees();
    this.checkIfProofExistsForThisItem();
    this.dialog = true;
  }
  closeDialog() {
    this.isOrderingProof = false;
    this.dialog = false;
  }
  /* Computed */

  /* Mounted */
  async mounted() {}
  /* Created */
  created() {}
  /* Created */
}
